import { render, staticRenderFns } from "./ReferenceCommentsPanel.vue?vue&type=template&id=634a5666&scoped=true&"
import script from "./ReferenceCommentsPanel.vue?vue&type=script&lang=js&"
export * from "./ReferenceCommentsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceCommentsPanel.vue?vue&type=style&index=0&id=634a5666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634a5666",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
